import styled from '@emotion/styled'

export const CalendarHeaderWrapper = styled.div`
   background-color: white;
   padding-left: 40px; 
   position: fixed;
   width: calc(100% - 78px);
   z-index: 4;

   @media (max-width:640px){
    width: 100%
}
`

export const CalendarDayWrapper = styled.div`
  border-right: 1px solid #c9c9c9;
  flex-grow: 1;
  min-width: 69px;
`

export const DayComponentsWrapper = styled.div`
  display: flex;
  `
